<div class="flex flex-col gap-4">
    <div class="grid grid-cols-6 gap-4 mb-8">
        <ng-container *ngFor="let color of colors">
            <ng-container *ngFor="let size of sizes">
                <ng-container *ngFor="let disabled of size.includeDisabled ? [false, true] : [false]">
                    <ng-container *ngFor="let weight of weights">
                        <ng-container *ngFor="let kind of kinds">
                            <ng-container [ngSwitch]="kind">

                                <v2-button-wrapper [color]="color" [icon]="'arrow-right'" [text]="'button'"
                                    [size]="size.class" [variant]="kind" [bold]="weight.class === 'button-bold'"
                                    [disabled]="disabled"></v2-button-wrapper>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
    <!-- Icon, FAB and Mini FAB -->
    <div class="grid grid-cols-6 gap-4 mb-8">
        <button mat-fab aria-label="Example icon button with a heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>
        <button mat-mini-fab aria-label="Example icon button with a heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>
        <button mat-icon-button aria-label="Example icon button with a heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>

        <!-- accent -->

        <button mat-fab color="accent" aria-label="Example icon button with a heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>
        <button mat-mini-fab color="accent" aria-label="Example icon button with a heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>
        <button mat-icon-button color="accent" aria-label="Example icon button with a heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>

        <!-- primary -->

        <button mat-fab color="primary" aria-label="Example icon button with a heart
            icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>
        <button mat-mini-fab color="primary" aria-label="Example icon button with a
            heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>
        <button mat-icon-button color="primary" aria-label="Example icon button with a heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>

        <!-- warn -->

        <button mat-fab color="warn" aria-label="Example icon button with a heart

            icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>
        <button mat-mini-fab color="warn" aria-label="Example icon button with a
            heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>
        <button mat-icon-button color="warn" aria-label="Example icon button with a heart icon">
            <mat-icon svgIcon="heart"></mat-icon>
        </button>
    </div>
</div>